var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.5 3.5998c0-.99411.80589-1.8 1.8-1.8h5.4c.9941 0 1.8.80589 1.8 1.8v12.6l-4.5-2.25-4.5 2.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.d93928d4cfaa7952b7344e7d32302d77.svg";
export { ForwardRef as ReactComponent };